/**
 * track — fire-and-forget activity beacons (product views, cart adds).
 *
 * Posts to /api/activity. The request is best-effort: failures are swallowed so
 * tracking can never interfere with the shopping flow. Auth (when present) is
 * attached by the api interceptor, which lets the backend tie the event to the
 * logged-in user; the visitor/session ids mirror the analytics tracker so
 * anonymous activity can be stitched together too.
 */
import api from './api';

export function trackActivity(payload = {}) {
  try {
    const visitorId = localStorage.getItem('tt_vid') || undefined;
    const sessionId = sessionStorage.getItem('tt_sid') || undefined;
    const path = typeof window !== 'undefined' ? window.location.pathname : undefined;
    api.post('/activity', { visitorId, sessionId, path, ...payload }).catch(() => {});
  } catch (_) {
    /* never throw from a tracking call */
  }
}
